import type {
  AppMobileProfileEmployee,
  LC_AppMobileProfileEmployeeItem,
} from './appMobileProfileEmployees.types';


export function mapAppMobileProfileEmployee(
  item: LC_AppMobileProfileEmployeeItem,
): AppMobileProfileEmployee {
  return {
    employeeId: item.employeeId,
    rut: item.employeeTaxIdentificationNumber ?? '',
    fullName: item.fullName ?? '',
    appProfileId: item.appProfileId ?? null,
  };
}
